import { EmailAuthProvider, GoogleAuthProvider, OAuthProvider } from 'firebase/auth'

// auth.settings.appVerificationDisabledForTesting = true
export const googleAuthProvider = new GoogleAuthProvider()
export const appleAuthProvider = new OAuthProvider('apple.com')
appleAuthProvider.addScope('email')
appleAuthProvider.addScope('name')
export const passwordAuthProvider = new EmailAuthProvider()
